import { Component, ViewEncapsulation } from '@angular/core';
import { GtSessionStorageService } from '../../services/gt-session-storage.service';

@Component({
  selector: 'gt-app-loader',
  templateUrl: './gt-app-loader.component.html',
  styleUrls: ['./gt-app-loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GtAppLoaderComponent {
  constructor(private gtSessionStorageService: GtSessionStorageService) {
  }
  getStaticPath(resourseName: string) {
    return this.gtSessionStorageService.value("staticResourcePath") +"/"+ resourseName;
  }
}
